import { Component, OnInit } from '@angular/core';

import { AbstractPropertyEditorBase } from '../../types/property-editor.types';

@Component({
  selector: 'df-check-box-property-editor',
  templateUrl: './check-box-property-editor.component.html',
  styleUrls: ['./check-box-property-editor.component.css']
})
export class CheckBoxPropertyEditorComponent extends AbstractPropertyEditorBase implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}
}
